import React, { createContext, useContext, useState } from "react";

const LoadingContext = createContext(null);

export function useLoading() {
	return useContext(LoadingContext);
}

export function LoadingProvider({ children }) {
	const [loading, setLoading] = useState(false);

	const startLoading = () => setLoading(true);
  	const stopLoading = () => setLoading(false);

	return (
		<LoadingContext.Provider value={{ loading, startLoading, stopLoading }}>
			{children}
		</LoadingContext.Provider>
	);
}
